import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../config';
import './PayrollRuns.css';

function PayrollRuns() {
  const [runs, setRuns] = useState([]);
  const [showNewModal, setShowNewModal] = useState(false);
  const [newRun, setNewRun] = useState({
    period_month: new Date().getMonth() + 1,
    period_year: new Date().getFullYear()
  });
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    loadRuns();
  }, []);
  
  const loadRuns = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE}/api/payroll/runs`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!res.ok) {
        throw new Error('Erreur lors du chargement');
      }
      
      const data = await res.json();
      setRuns(data.runs || []);
    } catch (error) {
      console.error('Erreur chargement sessions:', error);
      alert('Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  };
  
  const handleCreateRun = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE}/api/payroll/runs`, {
        method: 'POST',
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newRun)
      });
      
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'Erreur lors de la création');
      }
      
      setShowNewModal(false);
      loadRuns();
      alert('Session créée avec succès !');
    } catch (error) {
      console.error('Erreur création session:', error);
      alert(error.message || 'Erreur lors de la création');
    }
  };
  
  const getStatusBadge = (status) => {
    const statusMap = {
      draft: { label: 'Brouillon', color: '#6B7280' },
      validated: { label: 'Validée', color: '#10B981' },
      closed: { label: 'Clôturée', color: '#3B82F6' }
    };
    
    const { label, color } = statusMap[status] || { label: status, color: '#6B7280' };
    
    return (
      <span className="status-badge" style={{ backgroundColor: color }}>
        {label}
      </span>
    );
  };
  
  const getMonthName = (month) => {
    const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    return months[month - 1];
  };
  
  if (loading) return <div className="loading">Chargement...</div>;
  
  return (
    <div className="payroll-runs">
      <div className="runs-header">
        <h1>📊 Sessions de Paie</h1>
        <button className="btn-new-run" onClick={() => setShowNewModal(true)}>
          + Nouvelle Session
        </button>
      </div>
      
      <div className="runs-list">
        {runs.map(run => (
          <div key={run.id} className="run-card">
            <div className="run-header">
              <h3>{getMonthName(run.period_month)} {run.period_year}</h3>
              {getStatusBadge(run.status)}
            </div>
            
            <div className="run-stats">
              <div className="stat">
                <span className="label">Bulletins</span>
                <span className="value">{run.pay_slips_count || 0}</span>
              </div>
              <div className="stat">
                <span className="label">Total Net</span>
                <span className="value">
                  {run.total_net ? parseFloat(run.total_net).toLocaleString('fr-FR', {style: 'currency', currency: 'EUR'}) : '0,00 €'}
                </span>
              </div>
              <div className="stat">
                <span className="label">Coût Total</span>
                <span className="value">
                  {run.total_cost ? parseFloat(run.total_cost).toLocaleString('fr-FR', {style: 'currency', currency: 'EUR'}) : '0,00 €'}
                </span>
              </div>
            </div>
            
            <button 
              className="btn-view-run"
              onClick={() => window.location.href = `/payroll/runs/${run.id}`}
            >
              Voir les bulletins →
            </button>
          </div>
        ))}
      </div>
      
      {runs.length === 0 && (
        <div className="empty-state">
          <p>Aucune session de paie</p>
          <button className="btn-new-run" onClick={() => setShowNewModal(true)}>
            + Créer la première session
          </button>
        </div>
      )}
      
      {showNewModal && (
        <div className="modal-overlay" onClick={() => setShowNewModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Nouvelle Session de Paie</h2>
            
            <div className="form-group">
              <label>Mois</label>
              <select 
                value={newRun.period_month}
                onChange={(e) => setNewRun({...newRun, period_month: parseInt(e.target.value)})}
              >
                {[...Array(12)].map((_, i) => (
                  <option key={i} value={i + 1}>{getMonthName(i + 1)}</option>
                ))}
              </select>
            </div>
            
            <div className="form-group">
              <label>Année</label>
              <input 
                type="number"
                value={newRun.period_year}
                onChange={(e) => setNewRun({...newRun, period_year: parseInt(e.target.value)})}
              />
            </div>
            
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setShowNewModal(false)}>
                Annuler
              </button>
              <button className="btn-create" onClick={handleCreateRun}>
                Créer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PayrollRuns;

